import { Link, Text } from "@simplybusiness/mobius";

export const FooterContent = () => {
  return (
    <div className="mobius-footer-ctm__content">
      <Text elementType="h2">Important Information</Text>
      <p>
        The Comparethemarket Business insurance comparison service is provided
        by Simply Business. Simply Business is a trading name of Xbridge Limited
        which is authorised and regulated by the&nbsp;
        <Link
          href="https://www.fca.org.uk/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Financial Conduct Authority
        </Link>
        &nbsp;(Financial Services Registration No: 313348). Xbridge Limited (No:
        3967717) has its registered office at 4th Floor, Hylo, 105 Bunhill Row,
        London EC1Y 8LZ.
      </p>
      <p>Simply Business is not part of Compare the Market Limited.</p>
      <p>
        Comparethemarket is a trading name of Compare The Market Limited.
        Compare The Market Limited is an insurance intermediary, which is
        authorised and regulated by the&nbsp;
        <Link
          href="https://www.fca.org.uk/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Financial Conduct Authority
        </Link>
        &nbsp; (Firm Reference Number 778488).
      </p>
      <p>
        For help and information for health, accessibility or financial issues
        please visit our&nbsp;
        <Link
          href="https://www.comparethemarket.com/customer-support-hub/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Customer Support Hub
        </Link>
        .
      </p>
      <p>
        To find out how Comparethemarket works please click&nbsp;
        <Link
          href="https://www.comparethemarket.com/about-us/"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </Link>
        .
      </p>
      <p>
        You can find information about how comparethemarket.com process the data
        that they receive from Simply Business and any data you may provide
        elsewhere on the comparethemarket.com website in the
        Comparethemarket&nbsp;
        <Link
          href="https://www.comparethemarket.com/information/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy and Cookie Policy
        </Link>
        .
      </p>
      <Text elementType="h3" variant="small">
        Movies, Coffee & More
      </Text>
      <p>
        *To become a Rewards member, a qualifying product must be taken out. 1
        membership per year. Discount details, exclusions and restrictions vary
        per Reward. Full&nbsp;
        <Link
          href="https://www.comparethemarket.com/information/rewards-terms/"
          target="_blank"
          rel="noopener noreferrer"
        >
          T&Cs
        </Link>
        &nbsp;apply in addition to the below.
      </p>
      <ul>
        <li>
          <strong>Enjoy 2 for 1 cinema tickets: </strong> Tuesdays or
          Wednesdays. Participating cinemas. 2 standard tickets, cheapest free.
        </li>
        <li>
          <strong>Enjoy 50% off takeaway pizza:</strong> App only. Minimum
          spend, delivery fees & radius vary by outlet. Card only. Geographical
          restrictions may apply.
        </li>
        <li>
          <strong>Enjoy 25% off dining out:</strong> App only. Days
          available/no. of diners vary by participating restaurant/outlet.
          Restrictions may apply to special menus.
        </li>
        <li>
          <strong>Enjoy 25% off barista-made drinks & pastries:</strong> App
          only. At Caffè Nero. 2 codes per day.
        </li>
      </ul>
      <p>
        This site is protected by reCAPTCHA and the Google&nbsp;
        <Link
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </Link>
        &nbsp;and&nbsp;
        <Link
          href="https://policies.google.com/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </Link>
        &nbsp;apply.
      </p>
      <p>
        &copy; 2005 - {new Date().getFullYear()} Comparethemarket All rights
        reserved.
      </p>
    </div>
  );
};
